import React, { useState } from 'react';

function WebDesignModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Web Design",
      content: [
        "Overview of Web Design: User-Centered Design, Visual Design Principles",
        "HTML: Structure and Semantic Elements",
        "CSS: Styling, Colors, Fonts, and Layouts",
        "JavaScript Basics: Interactivity in Web Design",
        "Responsive Design: Mobile-first Approach",
        "Importance of Accessibility and Usability in Web Design",
        "Introduction to Web Design Tools"
      ]
    },
    {
      title: "Module 2: HTML & CSS Basics",
      content: [
        "Introduction to HTML: Elements, Tags, Attributes",
        "HTML5 Elements: Header, Footer, Article, Section",
        "CSS Syntax and Selectors: Styling HTML Elements",
        "CSS Box Model: Padding, Margin, Border",
        "Flexbox Layout for Responsive Design",
        "CSS Grid: Creating Complex Layouts",
        "Styling Forms and Input Elements",
        "Typography in Web Design: Fonts, Line Height, Spacing"
      ]
    },
    {
      title: "Module 3: JavaScript Basics for Web Design",
      content: [
        "Introduction to JavaScript: Variables, Functions, and Loops",
        "Event Handling: User Interactions with the Page",
        "DOM Manipulation: Accessing and Changing HTML Elements",
        "Handling Forms with JavaScript",
        "Working with JavaScript Objects and Arrays",
        "Validating Forms using JavaScript",
        "Introduction to JavaScript Libraries and Frameworks (e.g., jQuery)"
      ]
    },
    {
      title: "Module 4: Bootstrap for Responsive Web Design",
      content: [
        "Introduction to Bootstrap: Grid System and Layout",
        "Responsive Design with Bootstrap's Grid System",
        "Building Navigation with Bootstrap",
        "Creating Buttons, Alerts, and Cards in Bootstrap",
        "Customizing Bootstrap Components",
        "Building Forms with Bootstrap",
        "Using Bootstrap Modals, Carousels, and Tooltips"
      ]
    },
    {
      title: "Module 5: React for Web Design",
      content: [
        "Introduction to React: Components, JSX, Props, and State",
        "Creating Functional and Class Components",
        "Handling Events in React",
        "Managing State with useState Hook",
        "Using React Router for Navigation",
        "Form Handling in React",
        "Building a Responsive Layout in React with Flexbox and Grid"
      ]
    },
    {
      title: "Module 6: Full-Stack Web Design Project",
      content: [
        "Building a Complete Web Application using HTML, CSS, JavaScript, Bootstrap, and React",
        "Implementing Responsiveness for Different Devices",
        "Creating Interactive Forms and Handling User Input",
        "Designing a Portfolio Website",
        "Deploying a Web Application"
      ]
    }
  ];

  return (
    <div className="container">
      <h1 className="text-center py-5">Web Design Module</h1>
      <div className="row justify-content-center">
        {modules.map((module, index) => (
          <div
            key={index}
            className="col-12 col-md-6 mb-3"
            style={{ marginBottom: '20px' }}
          >
            <div
              className="module-header p-3 d-flex justify-content-between align-items-center"
              style={{
                backgroundColor: '#f8f9fa',
                border: '1px solid #ddd',
                cursor: 'pointer',
                borderRadius: '5px',
              }}
              onClick={() => toggleModule(index)}
            >
              <h5>{module.title}</h5>
              <span
                style={{
                  fontSize: '18px',
                  transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s',
                }}
              >
                ▼
              </span>
            </div>

            {openModule === index && (
              <div
                className="module-content p-3 mt-3"
                style={{
                  border: '1px solid #ddd',
                  borderTop: 'none',
                  backgroundColor: '#ffffff',
                  borderRadius: '5px',
                }}
              >
                <ul>
                  {module.content.map((item, itemIndex) => (
                    <li key={itemIndex} style={{ marginBottom: '10px' }}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default WebDesignModule;
